/*
 * Hearth & Oak product page helpers
 *
 * - Stock message (snippets/ho-stock-status.liquid): follows the selected variant, or every
 *   pair of a multi-pair bundle (ho:bundle-change from assets/ho-bundle.js). Uses real inventory only.
 * - Sale countdown (snippets/ho-promo.liquid): counts to a fixed end time and removes the sale
 *   badge and countdown when it passes.
 * - Size guide dialog (snippets/ho-size-guide.liquid) and rating link smooth scroll.
 */
(function () {
  'use strict';

  if (window.HOProduct) {
    window.HOProduct.initAll();
    return;
  }

  function fill(template, values) {
    return (template || '').replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] !== undefined ? values[key] : m;
    });
  }

  /* Stock message
     ======================================================================== */
  function Stock(el) {
    this.el = el;
    this.text = el.querySelector('[data-ho-stock-text]');
    this.data = JSON.parse(el.querySelector('[data-ho-stock-json]').textContent);
    this.section = el.closest('[data-section-type="product"]') || document;
    this.bundleState = null;

    var self = this;
    this.section.addEventListener('variantChange', function (evt) {
      self.nativeVariant = evt.detail && evt.detail.variant;
      // Impulse fires this before the bundle re-applies its state; let the bundle go first.
      setTimeout(function () { self.render(); }, 0);
    });
    this.section.addEventListener('ho:bundle-change', function (evt) {
      self.bundleState = evt.detail;
      self.render();
    });
    if (this.section.hoBundleState) {
      this.bundleState = this.section.hoBundleState;
      this.render();
    }
  }

  Stock.prototype = {
    info: function (variant) {
      if (!variant) return null;
      return this.data.variants[String(variant.id)] || null;
    },

    // Returns { state, text } for a stock quantity (null = not tracked).
    evaluate: function (qty, available, extra) {
      var d = this.data;
      var s = d.strings;
      if (!available) return { state: 'out', text: s.soldOut };
      if (qty === null || qty === undefined) return { state: 'ok', text: s.ok };
      if (qty > 0 && qty <= d.countThreshold) {
        return { state: 'low', text: qty === 1 ? s.countOne : fill(s.count, { count: qty }), extra: extra };
      }
      if (qty <= d.lowThreshold) return { state: 'low', text: s.low, extra: extra };
      return { state: 'ok', text: s.ok };
    },

    render: function () {
      var result;
      var size = '';
      var self = this;

      if (this.bundleState && this.bundleState.multi) {
        // Several pairs: report the tightest stock among the chosen sizes,
        // counting how many of each size are in the bundle.
        var chosen = {};
        this.bundleState.variants.forEach(function (v) {
          if (!v) return;
          chosen[v.id] = (chosen[v.id] || 0) + 1;
        });
        var ids = Object.keys(chosen);
        if (!ids.length) return;
        var worst = null;
        ids.forEach(function (id) {
          var info = self.data.variants[id];
          if (!info) return;
          var rank = !info.available ? -1 : (info.qty === null ? Infinity : info.qty);
          if (worst === null || rank < worst.rank) worst = { info: info, rank: rank };
        });
        if (!worst) return;
        result = this.evaluate(worst.info.qty, worst.info.available);
        size = worst.info.options[this.data.sizeIndex] || '';
        // With different sizes in the bundle, say which size is low.
        if (result.state !== 'ok' && ids.length > 1 && size && result.text.indexOf('{size}') === -1) {
          result.text += ' (' + size + ')';
        }
      } else {
        var variant = this.nativeVariant;
        if (!variant) {
          var input = this.section.querySelector('form[action*="/cart/add"] [name="id"]');
          variant = input ? { id: input.value } : null;
        }
        var info = this.info(variant);
        if (!info) return;
        result = this.evaluate(info.qty, info.available);
        size = info.options[this.data.sizeIndex] || '';
      }

      this.text.textContent = fill(result.text, { size: size });
      this.el.classList.remove('ho-stock--ok', 'ho-stock--low', 'ho-stock--out');
      this.el.classList.add('ho-stock--' + result.state);
    }
  };

  /* Sale countdown
     ======================================================================== */
  function Countdown(el) {
    this.el = el;
    this.end = parseInt(el.dataset.end, 10) * 1000;
    this.parts = {
      days: el.querySelector('[data-days]'),
      daysValue: el.querySelector('[data-days] [data-value]'),
      hours: el.querySelector('[data-hours]'),
      minutes: el.querySelector('[data-minutes]'),
      seconds: el.querySelector('[data-seconds]')
    };
    this.tick = this.tick.bind(this);
    this.tick();
    if (!this.expired) this.timer = setInterval(this.tick, 1000);
  }

  Countdown.prototype = {
    pad: function (n) { return n < 10 ? '0' + n : String(n); },

    tick: function () {
      var left = Math.floor((this.end - Date.now()) / 1000);
      if (!(left > 0)) {
        this.expire();
        return;
      }
      var days = Math.floor(left / 86400);
      var hours = Math.floor((left % 86400) / 3600);
      var minutes = Math.floor((left % 3600) / 60);
      var seconds = left % 60;
      var p = this.parts;
      if (p.days) {
        p.days.hidden = days === 0;
        p.daysValue.textContent = days;
      }
      if (p.hours) p.hours.textContent = this.pad(hours);
      if (p.minutes) p.minutes.textContent = this.pad(minutes);
      if (p.seconds) p.seconds.textContent = this.pad(seconds);
    },

    // The sale is over: remove the sale badge and countdown, keep the regular offer message.
    expire: function () {
      this.expired = true;
      clearInterval(this.timer);
      this.el.querySelectorAll('[data-ho-promo-sale]').forEach(function (node) { node.remove(); });
      if (!this.el.querySelector('.ho-promo__heading, .ho-promo__text, .ho-promo__savings')) {
        this.el.remove();
      }
    }
  };

  /* Size guide dialog
     ======================================================================== */
  function bindDialogs(scope) {
    scope.querySelectorAll('[data-ho-dialog-open]:not([data-ho-ready])').forEach(function (btn) {
      btn.setAttribute('data-ho-ready', '');
      var dialog = document.getElementById(btn.getAttribute('data-ho-dialog-open'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      // Move to <body> so the product column's stacking and transforms can't clip it.
      document.body.appendChild(dialog);
      btn.addEventListener('click', function () { dialog.showModal(); });
      dialog.addEventListener('click', function (evt) {
        if (evt.target === dialog || evt.target.closest('[data-ho-dialog-close]')) dialog.close();
      });
    });
  }

  /* Rating link: smooth scroll to the reviews section
     ======================================================================== */
  function bindRatingLinks(scope) {
    scope.querySelectorAll('[data-ho-rating-link]:not([data-ho-ready])').forEach(function (link) {
      link.setAttribute('data-ho-ready', '');
      link.addEventListener('click', function (evt) {
        // The chosen section, or the review carousel when that section isn't on the page.
        var target = document.getElementById(link.getAttribute('href').slice(1)) || document.querySelector('.ho-reviews-carousel');
        if (!target) return;
        evt.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* Sticky gallery offset: clear the sticky site header (its height varies with the logo)
     ======================================================================== */
  function setStickyOffset() {
    var header = document.querySelector('.site-header');
    var wrapper = document.querySelector('[data-sticky="true"]');
    var offset = header && wrapper ? header.offsetHeight + 16 : 20;
    document.documentElement.style.setProperty('--ho-sticky-top', offset + 'px');
  }

  /* Gallery thumbnail arrows: only show an arrow when there is more to scroll that way
     ======================================================================== */
  function bindThumbArrows(scope) {
    scope.querySelectorAll('.ho-gallery-col .product__thumbs[data-position="below"]:not([data-ho-ready])').forEach(function (thumbs) {
      thumbs.setAttribute('data-ho-ready', '');
      var scroller = thumbs.querySelector('.product__thumbs--scroller');
      var prev = thumbs.querySelector('.product__thumb-arrow--prev');
      var next = thumbs.querySelector('.product__thumb-arrow--next');
      if (!scroller || !prev || !next) return;
      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        prev.classList.toggle('hide', scroller.scrollLeft <= 2);
        next.classList.toggle('hide', max <= 2 || scroller.scrollLeft >= max - 2);
      }
      scroller.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Impulse moves to the previous/next image; also reveal more thumbnails
      prev.addEventListener('click', function () { setTimeout(update, 400); });
      next.addEventListener('click', function () { setTimeout(update, 400); });
      update();
      setTimeout(update, 800); // after images and Impulse's slider settle
    });
  }

  window.HOProduct = {
    initAll: function () {
      setStickyOffset();
      bindThumbArrows(document);
      document.querySelectorAll('[data-ho-stock]:not([data-ho-ready])').forEach(function (el) {
        el.setAttribute('data-ho-ready', '');
        try { new Stock(el); } catch (e) { if (window.console) console.error('[Hearth & Oak stock]', e); }
      });
      document.querySelectorAll('[data-ho-promo][data-end]:not([data-ho-ready])').forEach(function (el) {
        el.setAttribute('data-ho-ready', '');
        new Countdown(el);
      });
      bindDialogs(document);
      bindRatingLinks(document);
    }
  };

  window.HOProduct.initAll();
  document.addEventListener('DOMContentLoaded', window.HOProduct.initAll);
  document.addEventListener('shopify:section:load', window.HOProduct.initAll);
  window.addEventListener('resize', setStickyOffset);
})();
